<div id="reset-password" fxLayout="column">
    <div id="reset-password-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
        <div id="reset-password-form" [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }">
            <div class="logo">
                <img src="assets/images/logos/emma-b.png" />
            </div>

            <div class="title">{{ "login.resetPassword.title" | translate }}</div>
            <div class="subtitle">
                {{ "login.resetPassword.policy" | translate: { minLength: minLength } }}
            </div>

            @if (!token) {
                <mat-error class="message">
                    {{ "login.resetPasswordError.invalidToken" | translate }}
                </mat-error>
                <button mat-button type="button" class="secondary-button" (click)="goToLogin()">
                    {{ "login.backToLogin" | translate }}
                </button>
            } @else if (success) {
                <div class="message success">
                    {{ "login.resetPassword.success" | translate }}
                </div>
                <button mat-raised-button color="accent" class="submit-button" (click)="goToLogin()">
                    {{ "login.backToLogin" | translate }}
                </button>
            } @else {
                <form name="resetPasswordForm" [formGroup]="resetPasswordForm" (ngSubmit)="resetPasswordForm.valid && submit()">
                    <mat-form-field>
                        <input matInput type="password" [placeholder]="'login.password.label' | translate" formControlName="password" />
                        @if (resetPasswordForm.get("password").hasError("required")) {
                            <mat-error>{{ "login.password.validation.required" | translate }}</mat-error>
                        }
                        @if (resetPasswordForm.get("password").hasError("minlength")) {
                            <mat-error>
                                {{ "login.resetPassword.validation.minLength" | translate: { minLength: minLength } }}
                            </mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field>
                        <input
                            matInput
                            type="password"
                            [placeholder]="'login.resetPassword.confirmPassword' | translate"
                            formControlName="confirmPassword"
                        />
                        @if (resetPasswordForm.get("confirmPassword").hasError("required")) {
                            <mat-error>{{ "login.resetPassword.validation.confirmRequired" | translate }}</mat-error>
                        }
                    </mat-form-field>

                    @if (error) {
                        <mat-error class="message">
                            {{ error | translate }}
                        </mat-error>
                    }

                    <button mat-raised-button color="accent" class="submit-button" [disabled]="resetPasswordForm.invalid || loading">
                        {{ "login.resetPassword.submit" | translate }}
                    </button>

                    <button mat-button type="button" class="secondary-button" (click)="goToLogin()">
                        {{ "login.backToLogin" | translate }}
                    </button>
                </form>
            }
        </div>
    </div>
</div>
